<template>
  <div>
    <div class="field-content">
      <p>Identifies volatility squeeze setups with structural compression.
        GMMA alignment plus low BBW or RVM signals coiled price action.
        Watch for potential expansion or breakout.</p>
    </div>

    <div class="squeeze-options" style="margin-top: 12px; margin-bottom: 8px;">
      <div class="field-content">
        <p-radiobutton id="squeeze_mild" name="squeeze_intensity" value="mild" v-model="settings.squeezeType" />
        <label for="squeeze_mild" style="cursor: pointer;">
          <strong>Mild:</strong> minor squeeze, loads of results
        </label>
      </div>

      <div class="field-content">
        <p-radiobutton id="squeeze_moderate" name="squeeze_intensity" value="moderate" v-model="settings.squeezeType" />
        <label for="squeeze_moderate" style="cursor: pointer;">
          <strong>Moderate:</strong> pretty good squeeze, some results
        </label>
      </div>

      <div class="field-content">
        <p-radiobutton id="squeeze_extreme" name="squeeze_intensity" value="extreme" v-model="settings.squeezeType" />
        <label for="squeeze_extreme" style="cursor: pointer;">
          <strong>Extreme:</strong> extreme squeeze, few results
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { BOLLINGER_SQUEEZE } from '../../../../utils/defaultScanValues';

export default {
  components: {},
  name: 'BollingerSqueeze',
  data() {
    return {
      scanType: "bollingerSqueeze",
      isLoading: false
    }
  },
  props: {
    favScanId: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'sendBollingerSqueezePatternRequest',
      'setBollingerSqueezeSettings',
      'cancelGuruScans',
      'saveguruScanRequest',
      'getUserScanList',
      'runAndUpdateScanSettings',
      'resetSavedScan'
    ]),
    async onScanClick() {
      this.isLoading = true
      if (this.favScanId) {
        const index = this.userSavedScans.findIndex((x) => { return x.id == this.favScanId })
        await this.runAndUpdateScanSettings(index)
        await this.getUserScanList()
      }
      else {

        await this.sendBollingerSqueezePatternRequest()
      }
      this.isLoading = false
    },
    onScanStop() {
      this.isLoading = false
      this.cancelGuruScans()
    },
    ResetScanDefaultSettings() {
      if (this.favScanId) {
        this.resetSavedScan(this.favScanId)
      }
      else {
        this.setBollingerSqueezeSettings(JSON.parse(JSON.stringify(BOLLINGER_SQUEEZE)))
      }
    },
    async saveScanSettings(name) {
      await this.saveguruScanRequest({
        scanName: name,
        scanType: 'bollingerSqueeze'
      })
      this.$store.commit('SCAN_POPUP', false)
      await this.getUserScanList()
    },

    preventDecimal(event) {
      if (event.key === '.' || event.key === ',' || event.key === '-') {
        event.preventDefault();
      }
    },

  },
  watch: {
    isValid: {
      handler(newVal) {
        this.$emit('valid', newVal);
      },
      immediate: true
    },
    isLoading: {
      handler(newVal) {
        this.$emit('loading', newVal);
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(['gurusScanSettings', 'userSavedScans']),
    selectWidth() {
      return 'width: 15%'
    },
    isValid() {
      return (
        !!this.settings &&
        (!this.settings.squeezeType || ['mild', 'moderate', 'extreme'].includes(this.settings.squeezeType))
      )
    },
    settings: {
      get() {
        let currentSettings;
        if (this.favScanId) {
          currentSettings = this.userSavedScans.find(x => x.id == this.favScanId)?.data?.settings
        } else {
          currentSettings = this.gurusScanSettings.bollingerSqueeze
        }
        if (currentSettings && !currentSettings.squeezeType) {
          this.$set(currentSettings, 'squeezeType', 'mild')
        }
        return currentSettings || {}
      },
      set(value) {
        this.setBollingerSqueezeSettings(value)
      }
    }
  }
}
</script>
<style scoped></style>
